import React from 'react';
import { blocks } from '../../data/blocks';
export function TrainingBlocks() {
  return <section aria-labelledby="blocks-heading" className="bg-forest" data-id="element-255" data-mp="2ahtn6lsfyrzb">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-256" data-mp="2ak62ssaq8q97">
        <h2 id="blocks-heading" className="mx-auto max-w-4xl text-center font-display text-[2.5rem] font-extrabold uppercase leading-[0.95] text-white sm:text-5xl md:text-6xl" data-id="element-257" data-mp="2el83ldkalada">
          Inside the plan — <span className="text-gold" data-id="element-258" data-mp="1mqnxlewp8lbt">six complete training blocks</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-lg leading-relaxed text-white/75" data-id="element-259" data-mp="1quvqloa6wnfu">
          One book, organized from your first week to your final reassessment.
        </p>

        <ol className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-260" data-mp="20kxa02rllhof">
          {blocks.map(block => <li key={block.number} className="flex flex-col rounded-xl border border-moss bg-deep p-6 sm:p-7" data-id="element-261" data-mp="134ht3i8u5wdv">
              <div className="flex items-center justify-between gap-4" data-id="element-262" data-mp="181rrhne7didu">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-gold font-display text-2xl font-extrabold text-forest" data-id="element-263" data-mp="3uek4r2u9n7lh">
                  {block.number}
                </span>
                <span className="text-xs font-bold uppercase tracking-[0.16em] text-white/60" data-id="element-264" data-mp="3llyxojzzypch">{block.weeks}</span>
              </div>
              <h3 className="mt-5 font-display text-2xl font-extrabold uppercase leading-tight text-white" data-id="element-265" data-mp="3gmmafy57rg9d">
                {block.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-white/75" data-id="element-266" data-mp="36phnvx7ghis1">{block.description}</p>
              <p className="mt-auto border-t border-moss pt-4 text-sm font-semibold leading-relaxed text-gold" data-id="element-267" data-mp="32pgxde731h4m">
                {block.tags.join(' · ')}
              </p>
            </li>)}
        </ol>

        <p className="mt-10 text-center font-display text-2xl font-extrabold uppercase text-white md:text-3xl" data-id="element-268" data-mp="10wsr0vz56dkm">
          Every block includes complete workout pages — <span className="text-gold" data-id="element-269" data-mp="1f2b82bq3mgt1">not just a list of topics.</span>
        </p>
      </div>
    </section>;
}